/**
 * Adresy eshopov dodávateľov — zástupný `{kod}` a kontrola schémy.
 *
 * Používa to sekcia v Nastaveniach. Backend tie isté pravidlá vynucuje
 * pri ukladaní (`_sablony_su_http`), ale tu ide o **neuloženú** hodnotu
 * z inputu, ktorá sa hneď vykresľuje ako skúšobný odkaz — bez kontroly
 * by sa do `href` dostalo `javascript:` ešte predtým, než sa čokoľvek
 * odošle na server.
 *
 * **Samotné adresy tu nie sú.** Predvolené sú v Pythone
 * (`DEFAULT_ESHOP_SABLONY`) a chodia z API v `eshop_sablony_default` —
 * druhý zoznam by sa pri oprave adresy rozišiel s tým, čo appka reálne
 * použije na odkaz.
 */

/** Dodávatelia, ktorých appka pozná (rovnaké kľúče ako v súpise). */
export interface EshopDodavatel {
  kluc: string;
  label: string;
  /** Čo o objednávaní u dodávateľa vieme (zobrazí sa pod poľom). */
  pomoc?: string;
}

export const ESHOP_DODAVATELIA: EshopDodavatel[] = [
  {
    kluc: "hranipex",
    label: "Hranipex",
    pomoc: "Vyhľadávanie podľa kódu (kovanie F000814, hrany HD 211381).",
  },
  {
    kluc: "jafholz",
    label: "JafHolz",
    pomoc: "Hľadá sa podľa dekoru (W960), nie podľa nášho kódu položky.",
  },
  {
    kluc: "demos",
    label: "Démos",
    pomoc: "Hľadá sa podľa čísla tovaru z ich cenníka (166105).",
  },
  {
    kluc: "twd",
    label: "TWD (Blum)",
    pomoc: "Hľadá sa podľa evidenčného čísla TWD (56-141741).",
  },
  {
    kluc: "hafele",
    label: "Häfele",
    pomoc:
      "Objednáva sa cez objednávkový formulár, nie vyhľadaním — sem patrí " +
      "odkaz na formulár, {kod} v ňom netreba. Kódy skopíruj tlačidlom „Kódy“.",
  },
  {
    kluc: "sklenarstvo_mier",
    label: "Sklenárstvo Mier",
    pomoc:
      "Objednáva sa objednávkovým formulárom, nie vyhľadaním — {kod} netreba.",
  },
];

/**
 * Je adresa bezpečná na vloženie do `href`?
 *
 * Povolené je len `http`/`https`. `javascript:`, `data:` a spol. by
 * z vlastného nastavenia spravili XSS na vlastnej appke.
 */
export function jeHttpUrl(url: string | undefined | null): boolean {
  const v = (url ?? "").trim().toLowerCase();
  return v.startsWith("http://") || v.startsWith("https://");
}

/**
 * Skúšobná adresa — `{kod}` nahradený vzorovým kódom.
 *
 * `{kod}` je **voliteľný** (Häfele má formulár, nie vyhľadávanie), takže
 * šablóna bez neho sa vráti tak, ako je.
 */
export function ukazkaUrl(sablona: string, vzorovyKod = "F000814"): string {
  return sablona.trim().replace("{kod}", encodeURIComponent(vzorovyKod));
}
